/**
 * @ngdoc directive
 * @name footer
 *
 * @description
 * Page footer
 *
 * DROPDOWN RÉSERVÉ AUX LIENS DU COMPTE CONNECTÉ
 */
module.directive('dropdown', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$rootScope', '$scope', '$location', '$document', '$state', 'profile', '$filter', 'headermanager', 'cart', 'lodash', '$window', '$timeout', 'youtubeEmbedUtils', function ($rootScope, $scope, $location, $document, $state, $profile, $filter, $headermanager, $cart, lodash, $window, $timeout, $youtubeEmbedUtils) {
            // Paramètre du dropdown
            $scope.dropdownOpening = "";
            $scope.defaultScreenName = "Mon menu";
            $scope.focusScreen = $scope.defaultScreenName;
            $scope.showDropdown = $profile.authorization.authenticated;
            $scope.header = $headermanager;
            $scope.instructorDropdown = $profile.authorization.role === "instructor"
            $scope.configDropdown = $rootScope.config;
            // Fonction de toggleDropDown (utilisé dans le template)
            $scope.toggleDropDown = function() {
                if($scope.dropdownOpening != ""){
                    $scope.dropdownOpening = "";
                } else {
                    $scope.dropdownOpening = "opened";
                }
            }
            $scope.isCurrentState = function (current) {
                var state = current.parentState || current.state;
                return $state.includes(state);
            };

            // modifie le setting du title du dropdown au click sur un lien
            $scope.updateDropDownTitle = function(item){
                if(item){
                    $scope.focusScreen = item.label;
                    $scope.dropdownOpening = "";
                }
            }

            // initie le setting du title du dropdown au chargement de la page
            $scope.initiateDropdownTitle = function(item){
                if ($scope.isCurrentState(item)) {
                    $scope.focusScreen = item.label;
                    $scope.dropdownOpening = "";
                }
            }

        }],
        templateUrl: 'src/components/dropdown/dropdown.html'
    };
});
